module.exports = __webpack_public_path__ + "img/bell.edcecff8.png";